import React from 'react';

export const AddCreditIcon = () => (
  <svg
    width="32px"
    height="23px"
    viewBox="0 0 32 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 65</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-65" transform="translate(-2.000000, -5.000000)">
        <g id="Icon/Illustrative/30px/ReceiveMoney">
          <g id="Request-Money-36px" transform="translate(2.000000, 2.000000)">
            <polygon id="bounds" points="0 0 26 0 26 26 0 26" />
            <g id="Group" transform="translate(1.000000, 4.000000)">
              <polygon
                id="Stroke-7"
                stroke="#00A86E"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="8.58013369 8.64023771 24.8546914 8.64023771 24.8546914 0.135468819 8.58013369 0.135468819"
              />
              <ellipse
                id="Oval-3"
                stroke="#5EDAB0"
                cx="16.7174126"
                cy="4.45487894"
                rx="2.17962827"
                ry="2.02494497"
              />
              <path
                d="M8.64829226,14.6675934 L13.9643599,16.3037659 C14.7020968,16.6119129 15.5579018,16.2805228 15.8748805,15.5628045 C16.1918592,14.8464948 15.8500636,14.0146739 15.1123267,13.7058226 L9.44995135,11.9136397 C9.44995135,11.9136397 6.26963587,11.4276478 0,13.1501015 L1.00771405,17.480007 C1.00771405,17.480007 4.30572151,16.7728537 5.08857996,16.7728537 C5.87181443,16.7728537 8.60956295,17.8367532 10.3666703,18.3748659 C12.1237777,18.913683 15.0841257,18.8936094 15.0841257,18.8936094 L20.8991623,15.9773062 C21.6440434,15.6846546 22.0027596,14.8609336 21.7023254,14.1372284 C21.4018912,13.4135232 20.5539826,13.0638203 19.8091014,13.3557676 L15.9930237,15.1663689"
                id="Stroke-1"
                stroke="#042F43"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
        <g id="Group-4-Copy" transform="translate(19.000000, 13.000000)">
          <circle id="Oval" fill="#FFFFFF" cx="7.5" cy="7.5" r="7.5" />
          <g
            id="Group-60"
            transform="translate(2.000000, 2.000000)"
            stroke="#042F43"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          >
            <path
              d="M-8.8817842e-15,5.25346236 C-8.8817842e-15,2.35250044 2.35250044,-2.29949393e-12 5.25346236,-2.29949393e-12 C8.15442427,-2.29949393e-12 10.5069247,2.35250044 10.5069247,5.25346236 C10.5069247,8.15442427 8.15442427,10.5069247 5.25346236,10.5069247 C2.35250044,10.5069247 -8.8817842e-15,8.15442427 -8.8817842e-15,5.25346236 L-8.8817842e-15,5.25346236 Z"
              id="Stroke-281"
            />
            <path
              d="M3.06451971,5.25346236 L7.2964755,5.25346236"
              id="Stroke-283"
            />
            <path
              d="M5.25346236,3.06451971 L5.25346236,7.2964755"
              id="Stroke-285"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
